import React, { Component } from 'react';
import {ButtonGroup, Button, OverlayTrigger, Tooltip,} from 'react-bootstrap';
import { toast } from 'react-toastify';
import Auth from '../../Auth/Auth';

import IsLoadingBar from '../isLoading';
import { SubsTable } from '../Analytics/KPITables';

const auth = new Auth();


function parseJwt(token) {

    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}


export default class SearchSubs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchSubs: [],
            noSearchSubs : false
        };
    }

    handleChange(e){
        this.setState({
            [e.target.name] : e.target.value
        });         
    }

    async searchSubs(){
        this.setState({
            isSaving : true
        });
        let jwt = parseJwt(localStorage.getItem("msal.idtoken"));
        let searchSub = {
            searchSubQuery : this.state.searchSubQuery,
            searchSubSource : this.state.searchSubSource,
            searchSubFreq : this.state.searchSubFreq
        };

        let accessToken = await auth.getToken();
        fetch(`/api/addSearchSub`,{
            method : "POST",
            headers : {
              "Content-Type": "application/json",
              'Authorization': "Bearer " + accessToken,
               withCredentials : true,
               crossDomain: true,
            },
            body: JSON.stringify(searchSub)
            }).then(response => {
                if(response.status !== 200)
                {   
                    let payload = [{
                        status : response.status,
                        rawmsg : response.statusText,
                        cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                        location: response.url,
                        timestamp : Date.now(),
                    }];
                    throw {
                        payload: payload,
                        error: new Error()
                      };
                }
                return  response.json();
              })
            .then(success => {
                toast(`Subscribed to Search Query - ${this.state.searchSubQuery} `, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                  });
                  this.setState({
                    searchSubQuery : '',
                    searchSubSource : '',
                    searchSubFreq : '',
                    isSaving : false
                  });
            }).catch((error) => {
                window.apiError(error);
            });
    }

    async getsearchSubs(){
        this.setState({
            isLoading : true
        });
        let accessToken = await auth.getToken();
        let jwt = parseJwt(localStorage.getItem("msal.idtoken"));

        fetch('/api/getSearchSubs', {
            method : "GET",
            headers : {
                'Authorization': "Bearer " + accessToken,
                "loggedinClientId" : jwt.oid,
                withCredentials : true,
                crossDomain: true
            }
        }).then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        }).then(data => {
            if(data && data.length > 0){
                this.setState({
                    searchSubs : data,
                    isLoading : false,
                    noSearchSubs : false
                });
            }  else {
                this.setState({
                    isLoading : false,
                    noSearchSubs : true
                });                
            }        
        }).catch((error) => {
            window.apiError(error);
        }); 
    }

    render() {
        return (
            <div id="search-subs">
                <div className="smart-panel-title">
                    <p className="pl-3 mb-0">
                        Search Subscriptions
                <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip>
                                    Subscribe to a search query and be notified by email when new results are added to Fetch
                        </Tooltip>
                            }>
                            <i className="far fa-question-circle tooltip-icon"></i>
                        </OverlayTrigger>
                    </p>
                    <span className="pl-3">Monitor fetch for new related content</span>
                </div>
                <input className="form-control" name="searchSubQuery" value={this.state.searchSubQuery} placeholder="Search query..." style={{ float: "unset" }} onChange={(e) => this.handleChange(e)}></input>
                <p className="mb-0"><strong style={{ fontSize: "12px" }} className="pl-3 mb-0">Source</strong></p>
                <select className="form-control" name="searchSubSource" style={{ float: "unset" }} onChange={(e) => this.handleChange(e)} defaultValue="All" value={this.state.searchSubSource}>
                    <option>All</option>
                    <option>TFS</option>
                    <option>D365</option>
                </select>
                <p className="mb-0"><strong style={{ fontSize: "12px" }} className="pl-3 mb-0">How often</strong></p>
                <p className="mb-1"><small className="pl-3">These results will be sent to your email</small></p>
                <ButtonGroup className="mb-0 pl-3" aria-label="Date buttons" data-toggle="buttons">
                    <Button type="radio" variant="secondary" className={this.state.searchSubFreq === "Weekly" ? "date-filter-btn active" : "date-filter-btn"} onClick={() => this.setState({ searchSubFreq: "Weekly" })}>Weekly</Button>
                    <Button type="radio" variant="secondary" className={this.state.searchSubFreq === "Bi-Weekly" ? "date-filter-btn active" : "date-filter-btn"} onClick={() => this.setState({ searchSubFreq: "Bi-Weekly" })}>Bi-Weekly</Button>
                    <Button type="radio" variant="secondary" className={this.state.searchSubFreq === "Monthly" ? "date-filter-btn active" : "date-filter-btn"} onClick={() => this.setState({ searchSubFreq: "Monthly" })}>Monthly</Button>
                </ButtonGroup>
                <div className="pl-3">
                    <Button variant="link" className="p-0 m-0" onClick={() => this.getsearchSubs()}><small>current search subscriptions</small></Button>
                </div>
                <div className="pl-3 w-100 d-inline-block">
                    <Button className="save-btn" onClick={() => this.searchSubs()} disabled={!this.state.searchSubQuery || !this.state.searchSubFreq}>{this.state.isSaving ? "Saving..." : "Save"}</Button>
                </div>

                {this.state.isLoading && (
                    <IsLoadingBar alttext={"Search subscriptions are loading"} />
                )}

                {this.state.noSearchSubs && (
                    <div className="pl-3 w-100 d-inline-block">
                        <h6>No search subs!</h6>
                        <small>You can add one above.</small>
                    </div>
                )}

                {this.state.searchSubs.length > 0 && (
                    <div className="pl-3">
                        <SubsTable data={this.state.searchSubs} />
                    </div>
                )}
            </div>
        );
    }
}